/** @param {number | string} value */
export function toDollars(value) {
	if (typeof value == 'number') {
		return value.toFixed(2);
	}
	return parseFloat(value).toFixed(2);
}

/** @param {number} value */
export function calcGST(value) {
	value = value * 0.15;
	return value.toFixed(2);
}

const LABELS = { inc: ' inc GST', ex: ' + GST', none: '' };

/** @typedef {keyof typeof LABELS} DollarLabel */

/**
 * Standard dollar display used by Dollar.svelte / ScriptDollar.svelte.
 * Accepts a number, a numeric string (currency symbols stripped) or an array of numbers; tax is
 * applied per item to 2dp before summing so totals match line-level rounding.
 * @param {number | string | number[]} amount
 * @param {{ label?: DollarLabel, addTax?: boolean, removeTax?: boolean, calcTax?: boolean, chargeGst?: boolean, gstRate: number }} options
 */
export function formatDollars(amount, options) {
	const { gstRate } = options;
	let { label = 'inc', addTax = false, removeTax = false, calcTax = false } = options;
	const chargeGst = options.chargeGst ?? true;

	// When GST is not charged (AU gst_approved) suppress tax and the label.
	if (!chargeGst) {
		label = 'none';
		addTax = false;
		removeTax = false;
		calcTax = false;
	}

	/** @type {number[]} */
	let amounts;
	if (typeof amount == 'string') {
		const parsed = Number.parseFloat(amount.replace(/[^\d.-]/g, ''));
		amounts = [isNaN(parsed) ? 0 : parsed];
	} else if (typeof amount == 'number') {
		amounts = [amount];
	} else {
		amounts = Array.isArray(amount) ? amount.map(Number) : [0];
	}

	const taxFactor = 1 + gstRate;
	const rounded = amounts.map((a) => {
		if (addTax) {
			a = a * taxFactor;
		} else if (removeTax) {
			if (a > 0) a = a / taxFactor;
		} else if (calcTax) {
			a = a * gstRate;
		}
		return Math.round(a * 100) / 100;
	});

	return '$' + rounded.reduce((a, b) => a + b, 0).toFixed(2) + LABELS[label];
}
